import { ForumOverview } from "@/types/api/audience-content-item.types";
import { ForumPost } from "@/types/api/forum.types";
import {
  ContentItemOpenLetter,
} from "@/types/api/open-letter.types";
import { Letter } from "@/types/content-types/Letter.type";
import { ContentStatus } from "@/types/content-types/Status.type";

export const transformContentItemOpenLetterToLetter = (
  openLetter: ContentItemOpenLetter,
): Letter => {
  return {
    id: openLetter.id,
    date_created: openLetter.creationTime || "",
    date_updated: openLetter.lastModificationTime || "",
    sort: openLetter.sort || 0,
    slug: openLetter.slug,
    status: openLetter.status as unknown as ContentStatus,
    title: openLetter.title,
    title_highlighted: openLetter.title,
    detail_title: openLetter.title || "",
    detail_title_highlighted: openLetter.title || "",
    description: openLetter.description || "", // Ensure it's a string
    content: openLetter.content || "", // Ensure it's a string
    categories: openLetter.themes?.map((theme) => ({ name: theme.name })) || [],
    downloadable_document: openLetter.downloadFileId,
    image: openLetter.imageId,
    requires_signup: openLetter.registrationRequired,
    bg_color: openLetter.backgroundColour || "",
    tags: openLetter.tags?.map((tag) => ({ name: tag.name })) || [],
  };
};

export const mapToForumPost = (source: ForumOverview): ForumPost => {
  return {
    age_categories: [],
    likes: [],
    status: "published",
    user_gender: "",
    id: source.id,
    date_created: source.creationTime,
    date_updated: source.lastModificationTime,
    title: source.title,
    content: source.message,
    categories: source.themes,
    likes_count: source.likesCount,
    slug: source.slug,
    user_name: source.authorName,
    user_age: source.authorAge,
    user_updated: source.lastModificationTime,
    comments: source.comments || [],
    tags: source.tags,
  };
};
